import { render } from "./IconDroplet.vue?vue&type=template&id=24b60c11"
import script from "./IconDroplet.vue?vue&type=script&lang=js"
export * from "./IconDroplet.vue?vue&type=script&lang=js"
script.render = render

export default script